module.exports = __webpack_public_path__ + "media/img/event/logo/htmi-94444dc938d9f1e09c497624f10efae1.jpg";